(function () {
  'use strict';

  var page = document.querySelector('[data-fl-page]') || document;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var emberField = page.querySelector('[data-embers]');
  if (emberField && !reducedMotion) {
    for (var i = 0; i < 16; i++) {
      var ember = document.createElement('span');
      ember.className = 'fl-ember';
      ember.style.left = (Math.random() * 100) + '%';
      ember.style.top = (60 + Math.random() * 40) + '%';
      ember.style.animationDuration = (10 + Math.random() * 8) + 's';
      ember.style.animationDelay = (Math.random() * 8) + 's';
      emberField.appendChild(ember);
    }
  }

  var revealElements = page.querySelectorAll('.fl-reveal');
  if ('IntersectionObserver' in window && !reducedMotion) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fl-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    revealElements.forEach(function (element) { revealObserver.observe(element); });
  } else {
    revealElements.forEach(function (element) { element.classList.add('fl-in'); });
  }

  var art = page.querySelector('[data-love-bg]');
  var thread = page.querySelector('[data-fl-thread]');
  if (art && thread && thread.getTotalLength && !reducedMotion) {
    var length = thread.getTotalLength();
    thread.style.strokeDasharray = length;
    thread.style.strokeDashoffset = length;
    var ticking = false;
    function updateThread() {
      var maximum = document.documentElement.scrollHeight - window.innerHeight;
      var progress = maximum > 0 ? Math.max(0, Math.min(window.scrollY / maximum, 1)) : 0;
      thread.style.strokeDashoffset = length * (1 - progress);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateThread);
        ticking = true;
      }
    }, { passive: true });
    updateThread();

    var stageTriggers = [
      { element: page.querySelector('[id^="fl-stage-apart-"]'), stage: 'apart' },
      { element: page.querySelector('[id^="fl-stage-approaching-"]'), stage: 'approaching' },
      { element: page.querySelector('[data-stage-trigger="together"]'), stage: 'together' }
    ].filter(function (item) { return item.element; });
    if ('IntersectionObserver' in window) {
      var stageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var trigger = stageTriggers.filter(function (item) { return item.element === entry.target; })[0];
          if (!trigger) return;
          page.querySelectorAll('[data-fl-stage]').forEach(function (figure) {
            figure.classList.toggle('on', figure.getAttribute('data-fl-stage') === trigger.stage);
          });
        });
      }, { threshold: 0.5 });
      stageTriggers.forEach(function (item) { stageObserver.observe(item.element); });
    }
  }

  var modal = page.id ? document.getElementById('fl-chapter-modal-' + page.id.replace('fl-', '')) : null;
  if (modal) {
    var modalBody = modal.querySelector('.fl-chmodal-body');
    var closeButton = modal.querySelector('.fl-chmodal-close');
    var previousFocus = null;
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (previousFocus) previousFocus.focus();
    }
    page.querySelectorAll('[data-chapter-trigger]').forEach(function (button) {
      button.addEventListener('click', function () {
        var template = document.getElementById(button.getAttribute('data-target'));
        if (!template) return;
        previousFocus = button;
        modalBody.replaceChildren(template.content.cloneNode(true));
        var title = modalBody.querySelector('h2');
        if (title) title.id = 'fl-chapter-modal-title-' + page.id.replace('fl-', '');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        closeButton.focus();
      });
    });
    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
    modal.querySelector('.fl-chmodal-cta').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  var mobileBar = page.querySelector('[data-mobile-buy]');
  var hero = page.querySelector('.fl-hero');
  if (mobileBar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      mobileBar.style.visibility = entries[0].isIntersecting ? 'hidden' : 'visible';
    }, { threshold: 0.15 }).observe(hero);
  }

  page.querySelectorAll('[data-amazon-paperback-link]').forEach(function (link) {
    link.addEventListener('click', function () {
      var eventData = {
        event: 'amazon_paperback_click',
        link_location: link.getAttribute('data-link-location') || 'unknown',
        destination_url: link.href
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('amazon_paperback_click', eventData);
      }
    });
  });
}());
